export class ShellContainerConsts {
    public static readonly session_service = 'session_service';
    public static readonly signup_service = 'signup_service';
    public static readonly legal_documents_service = 'legal_documents_service';
    public static readonly account_service = 'account_service';
    public static readonly theme_service = 'theme_service';
    public static readonly locale_service = 'locale_service';
    public static readonly key_value_cache = 'key_value_cache';
}
